import axios from 'axios';
import type { FilterableCustomField } from '@/models/customFieldFilterTypes';
import type { ClientsTablePage, ClientsTableParams } from '../models/clientsListTypes';

export default {
  async fetchTable(params: ClientsTableParams): Promise<ClientsTablePage> {
    const { data } = await axios.get('/clients/table', { params });
    return data;
  },

  async fetchCustomFields(): Promise<FilterableCustomField[]> {
    const { data } = await axios.get('/customfields');
    return Array.isArray(data) ? data : data?.customFields ?? [];
  },

  async deleteClient(clientId: string): Promise<void> {
    await axios.delete(`/clients/${clientId}`);
  },
};
